"use client"

import * as React from "react"
import { useRouter } from "next/navigation"
import { Search } from "lucide-react"
import { Button } from "@/components/ui/button"
import { GameSelector } from "./game-selector"
import { DaySelector } from "./day-selector"
import { RegionSelector } from "./region-selector"

export function LeagueSearch() {
  const router = useRouter()
  const [selectedGames, setSelectedGames] = React.useState<string[]>([])
  const [selectedDays, setSelectedDays] = React.useState<string[]>([])
  const [selectedRegions, setSelectedRegions] = React.useState<string[]>([])

  const handleSearch = () => {
    // Build search params and navigate to results
    const params = new URLSearchParams()
    if (selectedGames.length > 0) params.set("games", selectedGames.join(","))
    if (selectedDays.length > 0) params.set("days", selectedDays.join(","))
    if (selectedRegions.length > 0) params.set("regions", selectedRegions.join(","))
    
    // Navigate to leagues page with filters
    const url = params.toString() ? `/leagues?${params.toString()}` : "/leagues"
    router.push(url)
  }

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="bg-card/60 backdrop-blur-md border border-border rounded-xl p-4 md:p-6 border-glow-cyan">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 md:gap-4">
          <div className="md:col-span-1">
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2 block">
              Game / League
            </label>
            <GameSelector 
              selectedGames={selectedGames} 
              onSelectionChange={setSelectedGames} 
            />
          </div>
          
          <div className="md:col-span-1">
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2 block">
              Day
            </label>
            <DaySelector 
              selectedDays={selectedDays} 
              onSelectionChange={setSelectedDays} 
            />
          </div>
          
          <div className="md:col-span-1">
            <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2 block">
              Region
            </label>
            <RegionSelector 
              selectedRegions={selectedRegions} 
              onSelectionChange={setSelectedRegions} 
            />
          </div>
          
          <div className="md:col-span-1 flex items-end">
            <Button 
              onClick={handleSearch}
              className="w-full h-12 bg-primary hover:bg-primary/90 text-primary-foreground font-semibold text-base gap-2"
            >
              <Search className="h-5 w-5" />
              Find Leagues
            </Button>
          </div>
        </div>

        {/* Quick Stats */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-4 pt-4 border-t border-border/50 text-sm text-muted-foreground">
          <span><span className="text-primary font-semibold">127</span> leagues starting soon</span>
          <span className="hidden sm:inline">|</span>
          <span><span className="text-primary font-semibold">2,400+</span> active players</span>
          <span className="hidden sm:inline">|</span>
          <span><span className="text-primary font-semibold">8</span> regions covered</span>
        </div>
      </div>
    </div>
  )
}
